import React from 'react';

interface AddOrDeleteOfferProps {
    className: string;
    label: string;
    onClick: ((parameters: any) => void) | undefined;
}

export function AddOrDeleteOffer(content: AddOrDeleteOfferProps) {
    return (
        <div className="tooltip-container">
            <span className="tooltip">{content.label}</span>
            <button
                className={'btn-no-look btn-star' + content.className}
                onClick={content.onClick}
                aria-label={content.label}
            >
                <i className="icon-star"></i>
            </button>
        </div>
    );
}
